define([
    "core/utilities",
    'moment',
    'components/dropdown',
    'core/urls',
    'components/fake-progress',
    'core/browser-storage',
    'components/daterangepicker-v2'
],
function (
    utilities,
    moment,
    DD,
    urls,
    FakeProgress,
    browserStorage,
    drp
) {
    let nodes = {
        page: {
            canvas: document.querySelector(".canvas"),
            main: document.querySelector(".sb-page.dashboard"),
        },
        header: {
            wrap: document.querySelector("header.top"),
            dateSelectorWrap: document.querySelector("header.top .date-selector-wrap"),
            fullScreenToggle:  document.querySelector(".full-screen-toggle"),
            fullScreenLabel:  document.querySelector(".full-screen-toggle .label"),
            liveIcon: document.querySelector("header.top .live"),
        },
        topPerformers: {
            main: document.querySelector(".top-performers"),
            categoryWrap: document.querySelector(".top-performers .categories"),
            categories: document.querySelectorAll(".top-performers .categories .category"),
            slider: document.querySelector(".top-performers .slide-bar"),
            items: document.querySelectorAll(".top-performers .list .item"),
        },
        metrics: {
            wrap: document.querySelector(".metrics-header-wrap.dashboard"),
        },
        recentActivity: {
            sentimentSelectors: document.querySelectorAll(".recent-activity .sentiment-selectors .dot"),
            chipsWrap: document.querySelector(".recent-activity .chip-slider-wrap"),
            chips: document.querySelectorAll(".recent-activity .chips .chip"),
            slider: document.querySelector(".recent-activity .slide-bar"),
            items: document.querySelector(".recent-activity .items"),
        }
    }

    let topPerformersData;

    let availableTypes = document.querySelector(".sb-page.dashboard").dataset.access.split(",").filter(r => r !== '');

    let dateSelector;
    let scrollTimeout = 0;
    let scrollDelay;
    let fullScreenRefreshInterval;

    let dismissedNotices = {
        csat: browserStorage.getItem("dashboard-dismiss-csat-notice") || false,
        nps: {
            surveyCreated: browserStorage.getItem("dashboard-dismiss-nps-campaign-notice") || false,
            responsesReceived: browserStorage.getItem("dashboard-dismiss-nps-responses-notice") || false,
        },
        projects: {
            surveyCreated: browserStorage.getItem("dashboard-dismiss-projects-survey-notice") || false,
            responsesReceived: browserStorage.getItem("dashboard-dismiss-projects-responses-notice") || false,
        }
    }
    let surveyStatuses = '';
    let previousData = null;
    let currentData = null;
    let customerTss = nodes.page.main.dataset.tss;

    let startDateElement;
    let endDateElement;

    let defaultDateRange = [moment().subtract(90, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];

    let dateParams = {
        preset: "Last 90 days",
        date: defaultDateRange,
    }

    if(browserStorage.getItem("dashbard-date-params")) {
        dateParams = JSON.parse(browserStorage.getItem("dashbard-date-params"));
    }

    let recentActivityState = {
        sentiments: {
            positive: true,
            neutral: true,
            negative: true,
        },
        scoreType: 'all',
    }

    let loaderElement = document.querySelector(".marketing-loader");
    let progressLoader = new FakeProgress(
        document.querySelector(".marketing-loader .loader-bar-wrap-bar")
    );

    let resetRecentActivityFilters = () => {
        recentActivityState = {
            sentiments: {
                positive: true,
                neutral: true,
                negative: true,
            },
            scoreType: 'all',
        }

        nodes.recentActivity.sentimentSelectors.forEach((dot) => {
            dot.classList.add("active");
        })

        nodes.recentActivity.chips[0].click();
    }

    let generateMetricCard = (type, i) => {
        // Overlay text for NPS and Projects is subject to whether they 
        // have created a campaign (first priority) and whether they nave receieved responses (second priority)
        // NOTE - CSAT only has one overlay message, as CSAT Snippet creation is mandatory in onboadring flow
        let NPSOverlayText = `Create your first <strong>Net Promoter Score</strong> campaign.<br> 
        <a href="${urls['nps:campaign']()}">Click here</a>`;
        let ProjectsOverlayText = `Create your first <strong>Project Survey</strong>.<br>
        <a href="${urls['projects:survey_manager']()}">Click here</a>`
       
        if(surveyStatuses.hasCreatedNPSCampaign) {
            NPSOverlayText = "Waiting for your first response";
        }

        if(surveyStatuses.hasCreatedProjectSurvey) {
            ProjectsOverlayText = "Waiting for your first result";
        }

        let csatHelpdeskLinks = {
            'cw': 'https://docs.connectwise.com/SmileBack/040/020/040',
            'zd': 'https://docs.connectwise.com/SmileBack/040/050/020',
            'fd': 'https://docs.connectwise.com/SmileBack/040/030/030',
            'ks': 'https://docs.connectwise.com/SmileBack/040/040/020',
            'hl': 'https://docs.connectwise.com/SmileBack/040/070/010',
            'at': 'https://docs.connectwise.com/SmileBack/040/060/020',
            'sc': 'https://docs.connectwise.com/SmileBack/040/SmileBack_and_ScreenConnect_Integration',
        }

        let config = {
            csat: {
                title: "CSAT",
                responseName: "Reviews",
                overlayText: `Waiting for your first review.<br> For a reminder on how to 
                                add the survey to your ticketing system, <br>
                                <a href="${csatHelpdeskLinks[customerTss]}" target="_blank">click here</a>.`,
            },
            nps: {
                title: "NPS",
                responseName: "Responses",
                overlayText: NPSOverlayText,
            },
            projects: {
                title: "Project Surveys",
                responseName: "Ratings",
                overlayText: ProjectsOverlayText,
            },
        };

        // add classname to help position dot tooltips
        let className = 'left';
        if(availableTypes.length === 2 && i === 1) className = 'right';
        if(availableTypes.length === 3) {
            if(i === 1) className = 'middle';
            if(i === 2) className = 'right';
        }

        let hasOverlayClass = "has-overlay";
        let storageName = '';
    
        if(type === "csat") {
            storageName = "dashboard-dismiss-csat-notice";
            // if CSAT notice has been dismissed, or CSAT reviews have come in - don't display overlay
            if (dismissedNotices.csat || surveyStatuses.hasCSATReviews) {
                hasOverlayClass = "";
            }
        }
        if(type === "nps") {
            // NPS shows one of two potential "empty state" notices
            // Condition 1 - no campaign has been created yet
            // Condition 2 - campaign has been created but no responses yet
            storageName = "dashboard-dismiss-nps-campaign-notice";
            if(surveyStatuses.hasCreatedNPSCampaign) {
                storageName = "dashboard-dismiss-nps-responses-notice";
                if(dismissedNotices.nps.responsesReceived || surveyStatuses.hasNPSResponses) {
                    hasOverlayClass = "";
                }
            } else {
                if(dismissedNotices.nps.surveyCreated) {
                    hasOverlayClass = "";
                }
            }
        }
        if(type === "projects") {
            // same logic as NPS above
            storageName = "dashboard-dismiss-projects-survey-notice";
            if(surveyStatuses.hasCreatedProjectSurvey) {
                storageName = "dashboard-dismiss-projects-responses-notice";
                if(dismissedNotices.projects.responsesReceived || surveyStatuses.hasProjectResponses) {
                    hasOverlayClass = "";
                }
            } else {
                if(dismissedNotices.projects.surveyCreated) {
                    hasOverlayClass = "";
                }
            }
        }

        nodes.metrics.wrap.innerHTML += `
            <div class="card ${hasOverlayClass}" data-type="${type}">
                <div class="title">${config[type].title}</div>
                <div class="body-wrapper">
                    <div class="score-wrapper">
                        <div class="main-score"></div>
                        <div class="tooltip-wrap">
                            <div class="delta">
                                <div class="symbol"></div>
                                <div class="delta-score"></div>
                                <div class="sb-tooltip">
                                    Change in score since previous time period.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="sub-metrics">
                        <div class="wrap responses">
                            <div class="title">${config[type].responseName}</div>
                            <div class="value"></div>
                        </div>
                        <div class="wrap response-rate">
                            <div class="title">Response Rate</div>
                            <div class="value"></div>
                        </div>
                    </div>
                    <div class="score-dots ${className}"></div>
                </div>
                <div class="overlay" data-type="${type}">
                    <div class="text-wrap">
                        ${config[type].overlayText}
                    </div>
                    <div class="dismiss" data-dismiss-name=${storageName}><div class="char">×</div></div>
                </div>
            </div>
        `;
    } 

    let generateTypeName = (type) => {
        if(type === 'csat') return 'CSAT';
        if(type === 'nps') return 'NPS';
        if(type === 'projects') return 'Projects';
    }

    let generateScoreChip = (type, score) => {
        let output = '';

        if(type === 'csat') return '';
        if(type === 'projects') return '';
        if(type === 'nps') output = `${score}`;
        
        return `<span class="chip score">${output}</span>`;
    }

    let dotsCount = {
        csat: 0,
        nps: 0,
        projects: 0
    }

    let adjustMetricDots = () => {
        // function to hide dots that go beyond width of card
        // We don't use overflow:hidden because that would block the tooltip
        let dotWrappers = document.querySelectorAll(`.metrics-header-wrap .card .score-dots`);

        dotWrappers.forEach(wrapper => {
            let dots = wrapper.querySelectorAll(".dot");
            if(!dots.length) {
                wrapper.classList.add("hide");
                return;
            } else {
                wrapper.classList.remove("hide");
            }

            let dotWidth = dots[0].offsetWidth;
            let dotMargin = 10;

            dots.forEach(dot => {
                dot.classList.remove('hide')
            });
            
            if(wrapper.offsetWidth < (dotWidth + dotMargin) * dots.length) {
                let availableSpaces = Math.floor((wrapper.offsetWidth - 1) / (dotWidth + dotMargin));
                
                for (let index = availableSpaces; index < dots.length; index++) {
                    if(dots[index]) dots[index].classList.add("hide");      
                }
            }            
        })
    }

    let toggleCommentMoreButton = () => {
        nodes.recentActivity.items.querySelectorAll(".item .comment").forEach(comment => {
            let textWrap = comment.querySelector(".text-wrapper");
            let moreLink = comment.querySelector(".more-link");

            if(textWrap.offsetWidth < (comment.offsetWidth - 20)) {
                moreLink.classList.add("hide");
            }

            comment.classList.remove("checking");
        })
    }

    let generateURLs = (review) => {
        let output = {
            linkText: '',
            url: '',
        }

        if(review.type === "csat") {
            output.linkText = "Go to review";
            output.url = `${urls['csat:reviews'](review.link)}`
        }
        if(review.type === "nps") {
            output.linkText = "Go to NPS";
            output.url = `${urls['nps:response']()}`
        }
        if(review.type === "projects") {
            output.linkText = "Go to survey";
            output.url = `${urls['projects:results']()}?id=${review.link}`
        }

        return output;
    }

    let createMetricsDot = (review, index) => {
        if(dotsCount[review.type] > 20) return;
        
        dotsCount[review.type] ++;

        let type = review.type;
        let dotsWrapper = document.querySelector(`.metrics-header-wrap .card[data-type='${review.type}'] .score-dots`)

        let sentiment = utilities.generateSentiment(review.type, review.score);
        let link = generateURLs(review);
        let output = `<div class="dot ${sentiment}" data-index="${index}">
                        <div class="tooltip">
                            <div class="score ${sentiment}"></div>
                            <div class="text-wrap">
                                <strong>${moment(review.timestamp).fromNow()}</strong> from <span class="name">${review.name}</span>
                                <a href="${link.url}" class="button-tertiary next">${link.linkText}</a>
                            </div>
                        </div>
                    </div>`

        if(dotsWrapper) {
            dotsWrapper.innerHTML += output;
        }
    }

    let populateMetrics = (data) => {
        availableTypes.forEach(type => {
            let card = document.querySelector(`.metrics-header-wrap .card[data-type='${type}']`);
            let mainScore = card.querySelector(".main-score");
            let deltaWrap = card.querySelector(".delta");
            let deltaSymbol = card.querySelector(".delta .symbol");
            let deltaScore = card.querySelector(".delta .delta-score");
            let responses = card.querySelector(".responses .value");
            let responseRate = card.querySelector(".response-rate .value");

            mainScore.innerHTML = data[type].score ? data[type].score.toFixed(1) : "0.0";
            if(data[type].delta < 0) {
                deltaSymbol.innerHTML = "-";
                deltaScore.innerHTML = (data[type].delta * -1).toFixed(1)
                deltaWrap.classList.remove("positive");
                deltaWrap.classList.add("negative");
            } else {
                deltaSymbol.innerHTML = "+";
                deltaScore.innerHTML = (data[type].delta).toFixed(1)
                deltaWrap.classList.add("positive");
                deltaWrap.classList.remove("negative");
            }

            responses.innerHTML = data[type].review_count ? data[type].review_count : "0";
            responseRate.innerHTML = data[type].response_rate ? data[type].response_rate.toFixed(1) : "0.0";
        })

        let dismissCardNoticeButtons = document.querySelectorAll(".metrics-header-wrap .card .overlay .dismiss");
        dismissCardNoticeButtons.forEach(button => {
            button.addEventListener("click", () => {
                let name = button.dataset.dismissName;
                browserStorage.setItem(name, true)
                button.parentElement.parentElement.classList.remove("has-overlay");
            })
        })
    }

    let buildReviewHTML = (review, type) => {
        let link = generateURLs(review);
        let categoriesOutput = '';

        if(review.type === "projects") {
            let categories = '';
            review.questions.forEach(question => {
                categories += `
                    <div class="category">
                        <div class="name">${question.name}</div>
                        <div class="score">${question.value || "—"}</div>
                    </div>
                `
            })

            categoriesOutput = `
                <div class="categories-wrap">
                    ${categories}
                </div>
            `;
        }

        if(type === "all" || type === review.type) {
            let sentiment = utilities.generateSentiment(review.type, review.score);
            if(!recentActivityState.sentiments[sentiment]) return ''; // don't render if sentiment selector is disabled

            let comment = review.comment ? `<div class="comment checking"><div class="text-wrapper">${review.comment}
                                            </div><div class="more-link">More</div></div>` : '';

            let nameOutput = (review.name === "" || review.name === " ") ? "Unknown Contact" : review.name.replace(/[^a-z0-9áéíóúñü \.,_-]/gim,"").trim();
            
            return `
                <div class="item">
                    <div class="sentiment ${review.type} ${sentiment}"></div>
                    <div class="content">
                        <div class="title">
                            <a href="${link.url}"><strong>${moment(review.timestamp).fromNow()}</strong> from <span class="name">${nameOutput}</span></a>
                            <span class="chip type">${generateTypeName(review.type)}</span>
                            ${generateScoreChip(review.type, review.score)}
                        </div>
                        ${categoriesOutput}
                        ${comment}
                    </div>
                </div>
            `;
        }

        return '';
    }

    let renderReviews = (newData, type) => {
        let output = '';

        if(newData) {
            // clear metric dots
            let dotWrappers = document.querySelectorAll(".metrics-header-wrap .score-dots");
            dotWrappers.forEach(wrapper => wrapper.innerHTML = '');
        }

        if(!type) type = recentActivityState.scoreType; // get saved scoreType if not passed in
        if(type) recentActivityState.scoreType = type; // save scoreType if it is passed in
        
        currentData.reviews.forEach((review, i) => {
            output += buildReviewHTML(review, type);

            if(newData) {
                // rebuild metric dots
                createMetricsDot(review, i);
                // remove any metric card overlays that are no longer relevant
                let overlay = nodes.metrics.wrap.querySelector(`.overlay[data-type='${review.type}']`);
                if(overlay) overlay.remove();
            }
        })

        if(output === '') {
            output = '<div class="no-data">No results found.</div>';
        }

        nodes.recentActivity.items.innerHTML = output;

        // highlight new reviews in fullscreen mode
        if((previousData && previousData.reviews.length) && nodes.page.canvas.classList.contains("full-screen") && output !== '') {
            let topPreviousTimestamp = previousData.reviews[0].timestamp;
            let topCurrentTimestamp = currentData.reviews[0].timestamp;
            let highlightedReviews = document.querySelectorAll(".recent-activity .item.highlight");

            // remove previous highlighting
            highlightedReviews.forEach(review => {
                review.classList.remove("highlight");
            })
            
            if(topPreviousTimestamp !== topCurrentTimestamp) {
                let updatedReviews = document.querySelectorAll(".recent-activity .items .item");
                for (let i = 0; i < currentData.reviews.length; i++) {
                    if(topPreviousTimestamp >= currentData.reviews[i].timestamp) {
                        break;
                    }
                    updatedReviews[i].classList.add("highlight");
                }
                scrollTimeout = 10000;
                document.querySelector(".recent-activity .items").scrollTop = 0;
            }
        }

        toggleCommentMoreButton();
        adjustMetricDots();
    }

    let updateTopPerformers = (data, selection) => {
        let newItems = data[selection];
        let elements = nodes.topPerformers.items;
        
        elements.forEach((element, i) => {
            setTimeout(() => {
                element.classList.add("flip");
            }, 150 * i);

            setTimeout(() => {
                if(newItems && newItems[i]) {
                    element.classList.remove("hide-panel");
                    element.innerHTML = `
                        <div class="title">${newItems[i].name}</div>
                        <div class="score-wrap">
                            <div class="score">${newItems[i].net_csat_score.toFixed(1)}</div>
                            <div class="count">${newItems[i].count}</div>
                        </div>
                    `;
                } else {
                    element.classList.add("hide-panel");
                }
                element.classList.remove("flip");

                if(i === 4) {
                    if(elements[0].classList.contains("hide-panel")){
                        elements[0].innerHTML = `
                            <div class="empty">No results found.</div>
                        `;
                        elements[0].classList.remove("hide-panel");
                    }
                }
            }, 150 * (i + 1));
        })
    }

    let getData = async (autoRefresh, isPageLoadRequest) => {
        let url = `${urls['reports:dashboard-data'](dateParams.date[0], dateParams.date[1])}`;

        loaderElement.classList.remove("disabled");
        progressLoader.startLoading(15);

        resetRecentActivityFilters();

        await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if(response.status === 200) {
                return response.json()
            }
        })
        .then((data) => {            
            topPerformersData = data.topPerformers;
            surveyStatuses = data.statuses;

            dotsCount = {
                csat: 0,
                nps: 0,
                projects: 0
            }

            if(data.topPerformers && nodes.topPerformers.categoryWrap) {
                updateTopPerformers(data.topPerformers, "agents");
                nodes.topPerformers.categories[0].click();
            }

            if(isPageLoadRequest) {
                pageLoadEventListeners(); 
                 // generate metric cards based on user access to features
                 availableTypes.forEach((type, i) => {
                    generateMetricCard(type, i);
                })

                if(availableTypes.length === 1) {
                    nodes.page.main.classList.add("single-survey")
                    if(availableTypes.indexOf("csat") > -1) {
                        let topPerformers = nodes.topPerformers.main;
                        nodes.metrics.wrap.appendChild(topPerformers);
                    }
                    nodes.page.main.classList.add("compact-view");
                }
            }

            populateMetrics(data.metrics);

            previousData = currentData;
            currentData = data;
            scrollTimeout = 0;

            renderReviews(true, "all");

            // full screen auto-refresh logic
            if(currentData.reviews.length && (autoRefresh || nodes.page.canvas.classList.contains("full-screen"))) {                
                clearInterval(scrollDelay);
                setTimeout(() => {
                    initAutoScroll();
                }, scrollTimeout)
            }

            progressLoader.loadFinish();
            loaderElement.classList.add("disabled");
        });        
    }

    let initAutoScroll = () => {
        clearInterval(scrollDelay);

        let scrollableArea = document.querySelector(".recent-activity .items");
        let allItems = scrollableArea.querySelectorAll(".item");
        let rowsHeight = 0;
        let scrollHeight = scrollableArea.offsetHeight;
        let firstRepeatedRow;

        // clear any previously added duplicate rows
        scrollableArea.querySelectorAll(".scroll-repeat").forEach(item => {
            item.remove();
        })

        if(nodes.page.canvas.classList.contains("full-screen")) {
            for (let index = 0; index < allItems.length; index++) {
                let currentRow = allItems[index].cloneNode(true);              
                currentRow.classList.add("scroll-repeat");

                if(index === 0) {
                    currentRow.classList.add("first");
                    firstRepeatedRow = currentRow;
                }

                scrollableArea.appendChild(currentRow);
                rowsHeight += allItems[index].offsetHeight;
                
                if (rowsHeight > scrollHeight) {
                    break;
                }
            }
        }

        if(rowsHeight < scrollHeight) {
            // there weren't enough rows to require auto scroll. Remove duplicates and exit function.
            scrollableArea.querySelectorAll(".scroll-repeat").forEach(item => {
                item.remove();
            })
            return;
        }

        
        let scrollableAreaTopPosition = scrollableArea.getBoundingClientRect().top;

        scrollAmount = () => {
            // reset to the start of the loop if the repeated row reaches the top
            if((firstRepeatedRow.getBoundingClientRect().top) <= scrollableAreaTopPosition) {
                scrollableArea.scrollTop = 0;
            }
            scrollableArea.scrollBy(0, 1);
        }

        if(nodes.page.canvas.classList.contains("full-screen")) {
            scrollDelay = setInterval(scrollAmount, 50);
        }
    }

    let pageLoadEventListeners = () => {
        let fullScreenToggleTimeout;
        let topPerformersInterval;

        nodes.recentActivity.items.addEventListener("click", (event) => {
            if(event.target.classList.contains("more-link")) {
                let parent = event.target.parentElement;
                if(parent.classList.contains("open")) {
                    parent.classList.remove("open");
                    event.target.innerHTML = "More";
                } else {
                    parent.classList.add("open");
                    event.target.innerHTML = "Less";
                }
            }
        })

        nodes.header.fullScreenToggle.addEventListener("click", (event)=> {
            if(event.currentTarget.classList.contains("active")) {
                nodes.header.fullScreenToggle.classList.remove("active");
                nodes.page.canvas.classList.remove("full-screen");

                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.mozCancelFullScreen) { /* Firefox */
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) { /* Safari */
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) { /* IE11 */
                    document.msExitFullscreen();
                }

                nodes.header.fullScreenToggle.classList.remove("invisible");
                clearTimeout(fullScreenToggleTimeout);
                clearInterval(topPerformersInterval);

            } else {
                nodes.header.fullScreenToggle.classList.add("active");
                nodes.page.canvas.classList.add("full-screen");

                if(nodes.topPerformers.categoryWrap) {
                    topPerformersInterval = setInterval(() => {
                        let categories = document.querySelectorAll(".top-performers .category");
                        let nextCategory = '';
    
                        categories.forEach((category, i) => {
                            if(category.classList.contains("active")) {
                                nextCategory = i === (categories.length - 1) ? 0 : i + 1;
                            };
                        })
                        categories[nextCategory].click();
                    }, 15000)
                }

                if (document.documentElement.requestFullscreen) {
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.webkitRequestFullscreen) { /* Safari */
                    document.documentElement.webkitRequestFullscreen();
                } else if (document.documentElement.msRequestFullscreen) { /* IE11 */
                    document.documentElement.msRequestFullscreen();
                }

                fullScreenRefreshInterval = setInterval(() => {
                    clearInterval(scrollDelay);
                    getData(true);
                }, globals.settings.DASHBOARD_RELOAD_INTERVAL * 1000)
            }  
        });

        addEventListener("mousemove", (event) => {
            if (document.fullscreenElement || /* Standard syntax */
                document.webkitFullscreenElement || /* Chrome, Safari and Opera syntax */
                document.mozFullScreenElement || /* Firefox syntax */
                document.msFullscreenElement) 
            {
                nodes.header.fullScreenToggle.classList.remove("invisible");
                nodes.header.liveIcon.classList.add("invisible");
                
                clearTimeout(fullScreenToggleTimeout);

                fullScreenToggleTimeout = setTimeout(() => {
                    nodes.header.fullScreenToggle.classList.add("invisible")
                    nodes.header.liveIcon.classList.remove("invisible");
                }, 4000)
            }
        });

        const prefixes = ["", "moz", "webkit", "ms"]
            prefixes.forEach(prefix => {
                document.addEventListener(prefix + "fullscreenchange", () => {
                    let fullscreenElement = document.fullscreenElement || /* Standard syntax */
                    document.webkitFullscreenElement || /* Chrome, Safari and Opera syntax */
                    document.mozFullScreenElement || /* Firefox syntax */
                    document.msFullscreenElement /* IE/Edge syntax */;

                    if (fullscreenElement) {
                        nodes.header.fullScreenLabel.innerHTML = "Exit full screen";
                        nodes.header.fullScreenToggle.classList.add("active");
                        nodes.page.canvas.classList.add("full-screen");

                        let flexWrapperHeight = document.querySelector(".full-flex-wrapper").offsetHeight;
                        let headerHeight = nodes.header.wrap.offsetHeight;

                        nodes.page.canvas.style.minHeight = (flexWrapperHeight + headerHeight + 70) + "px";

                        clearInterval(scrollDelay);
                        document.querySelector(".recent-activity .items").scrollTop = 0;
                        setTimeout(() => {
                            initAutoScroll();
                        }, 3000)
                        
                    } else {
                        nodes.header.fullScreenLabel.innerText = "Full screen";
                        nodes.header.fullScreenToggle.classList.remove("invisible");
                        nodes.header.fullScreenToggle.classList.remove("active");
                        nodes.page.canvas.classList.remove("full-screen");
                        clearTimeout(fullScreenToggleTimeout);
                        clearInterval(topPerformersInterval);
                        clearInterval(fullScreenRefreshInterval);
                        nodes.header.liveIcon.classList.add("invisible");

                        clearInterval(scrollDelay);
                        document.querySelectorAll(".item.scroll-repeat").forEach(item => {
                            item.remove();
                        })
                    }
                });
            });

        let categorySliderConfig = {
            parent: nodes.topPerformers.categoryWrap,
            slider: nodes.topPerformers.slider,
            callback: (event) => {
                setTimeout(() => {
                    updateTopPerformers(topPerformersData, event.target.dataset.title);
                }, 100)
            },
        }

        nodes.topPerformers.categories.forEach(category => {    
            utilities.applySlider(category, categorySliderConfig)
        });

        if(nodes.recentActivity.chips.length === 2) {
            nodes.recentActivity.chipsWrap.remove();
        } else {
            let chipSliderConfig = {
                parent: nodes.recentActivity.chipsWrap,
                slider: nodes.recentActivity.slider,
                callback: (event) => {
                    renderReviews(false, event.target.dataset.title);
                    clearInterval(scrollDelay);
                    document.querySelector(".recent-activity .items").scrollTop = 0;
                    setTimeout(() => {
                        initAutoScroll();
                    }, 3000)
                },
                padding: 6
            }
    
            nodes.recentActivity.chips.forEach(chip => {    
                utilities.applySlider(chip, chipSliderConfig)
            })
        }

        nodes.recentActivity.sentimentSelectors.forEach(sentiment => {
            sentiment.addEventListener("click", () => {
                if(sentiment.classList.contains("active")) {
                    sentiment.classList.remove("active");
                    recentActivityState.sentiments[sentiment.dataset.type] = false;

                    // reset all sentiments to active/true if all three are disabled
                    if( !recentActivityState.sentiments.positive &&
                        !recentActivityState.sentiments.neutral &&
                        !recentActivityState.sentiments.negative
                    ) {
                        nodes.recentActivity.sentimentSelectors.forEach((element, i) => {
                            setTimeout(() => {
                                element.classList.add("active")
                            }, i * 100);
                        })
                        recentActivityState.sentiments.positive = true;
                        recentActivityState.sentiments.neutral = true;
                        recentActivityState.sentiments.negative = true;
                    }
                } else {
                    sentiment.classList.add("active");
                    recentActivityState.sentiments[sentiment.dataset.type] = true;
                }

                renderReviews(false, null);
            })
        })

        window.addEventListener("resize", () => {
            adjustMetricDots();
        });
    }

    return {
        init: function () {   
            getData(false, true);
            
            if(availableTypes.length === 2 && availableTypes.indexOf("csat") === -1) { 
                nodes.page.main.classList.add("compact-view");
            }
            
            drp.create(function (selection) {
                if(selection.lenght === 1) return;
                dateParams["preset"] = selection.preset;
                dateParams["date"] = [selection.start.format('YYYY-MM-DD'), selection.end.format('YYYY-MM-DD')];

                browserStorage.setItem("dashbard-date-params", JSON.stringify(dateParams));

                getData();
            });

            drp.set(dateParams);
        }
    }
});